import RequestedServicesForm from "../../components/forms/RequestedServicesForm";

export default function RequestedServices({ onNext, onBack }: any) {

  return (
    <RequestedServicesForm
      onNext={onNext}
      onBack={onBack}
    />
  );
}
